import React from "react";
import { createRoot } from "react-dom/client";
import App from "~/App.tsx";
import IESplashPage from "~/layouts/IESplashPage";
import { getIEVersion } from "~/common/helpers";

const rootContainer = document.getElementById("root");
const root = createRoot(rootContainer);
root.render(getIEVersion() ? <IESplashPage /> : <App />);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister().then((success) => {
            if (success) {
              console.log("SW unregistered successfully");
            }
          });
        });
      })
      .catch((error) => {
        console.log("SW unregistration failed: ", error);
      });
  });
}
